import {Injectable} from "@angular/core";
import {ErrorInterceptor} from "./ErrorInterceptor";
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { TokenStorage } from "../TokenStorage";
import { HttpClient } from "@angular/common/http";

declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class ApplicationsHttp {

    constructor(private http: HttpClient, private errorInterceptor: ErrorInterceptor, private tokenStorage: TokenStorage) {
    }

    getProductsAgent(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/productsforagent";
        let request = this.http.put(url, param);

        return request.pipe(map(response => response), catchError(this.errorInterceptor.handleErrorObs));
    }
}
